import { Routing } from './routing/index';

function App() {
  return (
    <>
        {/* <SideNav /> */}
          <Routing />
    </>
  );
}

export default App;